// Scroll is native. Three chapters transform the same song from sleeve to email to gift.
(() => {
  const root = document.querySelector('.delivery-story');
  if (!root) return;
  const pin = root.querySelector('.delivery-pin');
  const stage = root.querySelector('.delivery-stage');
  const album = root.querySelector('.delivery-album');
  const disc = root.querySelector('.delivery-disc');
  const mail = root.querySelector('.delivery-mail');
  const gift = root.querySelector('.delivery-gift');
  const thumbnail = gift.querySelector('img');
  const note = root.querySelector('.delivery-art-note');
  const chapters = [...root.querySelectorAll('[data-chapter]')];
  const navigation = root.querySelector('.delivery-navigation');
  const buttons = [...navigation.querySelectorAll('button')];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const short = matchMedia('(max-height: 619px)');
  const compact = matchMedia('(max-width: 768px)');
  let enhanced = false, frame = 0, active = -1, size = 260;
  let mailTarget = {x: 0, y: 0, size: 54}, giftTarget = {x: 0, y: 0, size: 64};
  const clamp = n => Math.max(0, Math.min(1, n));
  const mix = (a, b, t) => a + (b - a) * t;
  const ease = (p, start, end) => {const t = clamp((p - start) / (end - start)); return t * t * (3 - 2 * t);};
  const offset = (child, parent) => {
    const c = child.getBoundingClientRect(), p = parent.getBoundingClientRect();
    return {x: c.left - p.left + c.width / 2 - p.width / 2, y: c.top - p.top + c.height / 2 - p.height / 2, size: c.width};
  };
  function measure() {
    size = album.offsetWidth;
    mailTarget = offset(root.querySelector('.delivery-attachment-space'), mail);
    giftTarget = offset(thumbnail, gift);
  }
  function chapter(index) {
    if (active === index) return;
    active = index;
    root.dataset.stage = String(index);
    chapters.forEach((el, i) => {
      el.classList.toggle('is-active', i === index);
      el.setAttribute('aria-hidden', String(enhanced && i !== index));
      el.inert = enhanced && i !== index;
    });
    buttons.forEach((button, i) => {
      if (i === index) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
    });
    gift.inert = enhanced && index !== 2;
    gift.setAttribute('aria-hidden', String(gift.inert));
    if (gift.inert) gift.querySelector('audio').pause();
  }
  function draw() {
    frame = 0;
    if (!enhanced) return;
    const rect = root.getBoundingClientRect();
    const travel = Math.max(1, root.offsetHeight - pin.offsetHeight);
    const p = clamp(-rect.top / travel);
    const mobile = compact.matches;
    chapter(p >= (mobile ? .68 : .78) ? 2 : p >= (mobile ? .30 : .36) ? 1 : 0);
    const tuck = ease(p, .03, mobile ? .20 : .31);
    const intoMail = ease(p, mobile ? .20 : .30, mobile ? .43 : .54);
    const intoGift = ease(p, mobile ? .50 : .68, mobile ? .75 : .86);
    const handoff = ease(p, mobile ? .73 : .85, mobile ? .88 : .94);
    const mailY = 32 * (1 - intoMail) - 40 * intoGift;
    const giftY = 34 * (1 - intoGift);
    const x = mix(mix(-size * .16, 0, tuck), mailTarget.x, intoMail);
    const y = mix(0, mailTarget.y + mailY, intoMail);
    const scale = mix(1, mailTarget.size / size, intoMail);
    album.style.transform = `translate(-50%,-50%) translate(${mix(x, giftTarget.x, intoGift).toFixed(2)}px,${mix(y, giftTarget.y + giftY, intoGift).toFixed(2)}px) scale(${mix(scale, giftTarget.size / size, intoGift).toFixed(4)})`;
    album.style.opacity = String(1 - handoff);
    disc.style.transform = `translateX(${52 * (1 - tuck)}%) rotate(${mix(-25, 335, tuck)}deg)`;
    mail.style.opacity = String(intoMail * (1 - intoGift));
    mail.style.transform = `translate(-50%,-50%) translateY(${mailY}px)`;
    gift.style.opacity = String(intoGift);
    gift.style.transform = `translate(-50%,-50%) translateY(${giftY}px)`;
    thumbnail.style.opacity = String(handoff);
    note.style.opacity = String(1 - ease(p, .24, .34));
    if (rect.bottom <= 0 || rect.top >= innerHeight) gift.querySelector('audio').pause();
  }
  function requestDraw() { if (!frame) frame = requestAnimationFrame(draw); }
  function configure() {
    enhanced = !reduced.matches && !short.matches;
    root.classList.toggle('is-scroll-scene', enhanced);
    navigation.hidden = !enhanced;
    active = -1;
    if (!enhanced) {
      [album, disc, mail, gift, thumbnail, note].forEach(el => { el.style.removeProperty('transform'); el.style.removeProperty('opacity'); });
      chapter(2);
    } else { measure(); draw(); }
  }
  buttons.forEach((button, i) => button.addEventListener('click', () => {
    const travel = root.offsetHeight - pin.offsetHeight;
    // Skip controls use an immediate native scroll so they never force a long animation.
    window.scrollTo({top: scrollY + root.getBoundingClientRect().top + travel * [.02, .60, .97][i], behavior: 'instant'});
  }));
  window.addEventListener('scroll', requestDraw, {passive: true});
  window.addEventListener('resize', () => {measure(); requestDraw();}, {passive: true});
  reduced.addEventListener('change', configure);
  short.addEventListener('change', configure);
  compact.addEventListener('change', configure);
  if ('ResizeObserver' in window) new ResizeObserver(() => {measure(); requestDraw();}).observe(stage);
  document.fonts?.ready.then(() => {measure(); requestDraw();});
  configure();
})();
